import axios from "axios";
import { logout } from "./../helpers";

const baseDomain = process.env.VUE_APP_URL_BASE;
const baseURL = `${baseDomain}/api`

const api = axios.create({
  baseURL
});

// Sistema bloqueado (bloqueio_temp ou data/hora agendada): a API responde 423
// em qualquer rota autenticada. Derruba a sessão uma única vez, mesmo com
// várias requisições em paralelo.
let derrubando = false;

api.interceptors.response.use(
  response => response,
  error => {
    const resp = error.response;
    const logado = !!localStorage.getItem("token");

    if (resp && resp.status === 423 && resp.data && resp.data.error === "sistema_bloqueado" && logado && !derrubando) {
      derrubando = true;
      alert(resp.data.mensagem || "Sistema bloqueado para acesso.");
      logout();
      setTimeout(() => { derrubando = false; }, 2000);
    }

    return Promise.reject(error);
  }
);

export default api;
